import React, { useEffect, useState } from 'react'
import Spining from '../UI/Spining/Spining'
import ReactDatePicker from "react-datepicker";
import AdvanceDataTable from '../UI/Table/AdvanceDataTable';
import AdminLayout from '../UI/Layout/AdminLayout';
import Title from '../UI/Text/Title';
import Axios from '../../axios/Axios';
import Select from "react-select";
import { HOST_URL, HOST_URL_DB2, NODE_HOST_URL, NODE_HOST_URL_v1 } from '../Dashboard/api/Api';
import { userloginDetails } from '../Utils/AdminAuth';
import { EMPLOYEE_CAMPAIGN_DATA, EMPLOYEE_RCS_CAMPAIGN_DATA, EMPLOYEE_SMS_CAMPAIGN_DATA } from '../UI/Table/ColumnConst';
import { faArrowUp, faCalendarAlt, faInfoCircle, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IoLogoWhatsapp } from 'react-icons/io';
import { FaSms } from 'react-icons/fa';
import RcsImage from "../Dashboard/assets/img/rcs.svg-removebg-preview.png";
import dayjs from 'dayjs';
import WhatsappCampaignListPreview from '../Dashboard/whatsapp/components/WhatsappCampaignListPreview';
import RcsPreview from '../Dashboard/campaign/Rcs/RcsPreview';

const AdminCampaignSummaryReport = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const adminType = lStorage.user.isAdmin;

    const [isLoading, setIsLoading] = useState(false);
    const [fromdate, setFromdate] = useState(new Date());
    const [todate, setTodate] = useState(new Date());
    const [channel, setChannel] = useState('whatsapp')
    const [allUsers, setAllUsers] = useState('')
    const [selecteduser, setSelectedusers] = useState("");
    const [campaignData, setCampaignData] = useState([]);
    const [totalCost, setTotalCost] = useState(null);
    const [totalFailed, setTotalFailed] = useState(null);
    const [totalDelivered, setTotalDeliverd] = useState(null);
    const [totalOptout, setTotalOptout] = useState(null);
    const [totalDnd, setTotalDnd] = useState(null);
    const [totalData, setTotalData] = useState(null);
    const [totalSent, setTotalSent] = useState(null);
    const [totalRead, setTotalRead] = useState(null);
    const [totalRcsOptout, setTotalRcsOptout] = useState(null)
    const [openTemplatePopup, setOpenTemplatePopup] = useState(false);
    const [templateDetails, setTemplateDetails] = useState(null);
    const [templateType, setTemplateType] = useState("")
    const [show, setShow] = useState(false);
    const [cardDynamicDataArray, setCardDynamicDataArray] = useState({
        media: null,
        card_title: '',
        card_description: '',
        temp_suggestion: []
    })

    const customStyles = {
        control: (provided) => ({
            ...provided,
            cursor: "pointer",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (style) => ({
            ...style,
            fontSize: "12px",
        }),
    };

    useEffect(() => {
        allUserList();
        CampaignReports();
    }, []);

    const userHandler = (e) => {
        setSelectedusers(e.value);
    };

    const handleChannelChange = (e) => {
        setChannel(e.target.value)
        setCampaignData([]);
    }

    const currentDate = (currentDate) => {
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    const allUserList = async () => {
        try {
            let { data } = await Axios.post(`${HOST_URL}/admin_user_list.php`, {
                user_id: userId,
                method: "retrieve_all_user",
                type: adminType,
                token: userToken,
            });

            if (data.success) {
                let filterData = data.data.map((x) => {
                    return { label: x.email, value: x.id };
                });
                setAllUsers(filterData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const CampaignReports = async () => {
        setIsLoading(true);
        try {
            let url =
                channel === "whatsapp"
                    ? `${HOST_URL}/bulk_campaign_sms.php`
                    : channel === "sms"
                        ? `${HOST_URL_DB2}/bulk_campaign_sms.php`
                        : channel === "rcs"
                            ? `${NODE_HOST_URL}/rcs`
                            : null;

            if (!url) return;

            let { data } = await Axios.post(url, {
                user_id: userId,
                method: channel === "rcs" ? "rcs_camp" : "retrieve_admin",
                token: userToken,
                channel: channel,
                from_date: currentDate(fromdate),
                to_date: currentDate(todate),
                seacrh_user_id: selecteduser || "",
            });

            if (data.success) {
                let totalCost = 0;
                let totaldelivered = 0;
                let totaloptout = 0;
                let totalfailed = 0;
                let contactCount = 0;
                let totalsent = 0;
                let totalread = 0;
                let totaldnd = 0;
                let totalRcsOptout = 0;

                const dataset = selecteduser
                    ? data.data.filter((x) => x.user_id === selecteduser)
                    : data.data;

                dataset.forEach((item) => {
                    totalCost += parseFloat(item.campaign_cost);
                    totaldelivered += item.delivered;
                    totaloptout += item.optout;
                    totaldnd += item.dnd;
                    totalsent += item.sent;
                    totalread += item.read;
                    totalfailed += item.failed;
                    contactCount += item.contact_count;
                    totalRcsOptout += item.optout_count;
                });

                setCampaignData(dataset);
                setTotalCost(totalCost);
                setTotalDeliverd(totaldelivered);
                setTotalRead(totalread);
                setTotalSent(totalsent);
                setTotalFailed(totalfailed);
                setTotalOptout(totaloptout);
                setTotalDnd(totaldnd);
                setTotalData(contactCount);
                setTotalRcsOptout(totalRcsOptout);
            }
        } catch (error) {
            console.log(error);
        }
        setIsLoading(false);
    };


    const RcsCampaignReport = async () => {
        setIsLoading(true)
        let paramData = {
            user_id: userId,
            token: userToken,
            fromdate: currentDate(fromdate),
            todate: currentDate(todate),
            method: "rcs_camp"
        }
        let { data } = await Axios.post(`${NODE_HOST_URL}/reseller_camp_report`, paramData)
        if (data.success) {
            let totalCost = 0
            let totaldelivered = 0;
            let totaloptout = 0;
            let totalfailed = 0;
            let contactCount = 0;
            let totalsent = 0;
            let totalread = 0;
            let totaldnd = 0
            let totalRcsOptout = 0
            if (selecteduser) {
                let filterData = data.data.filter(x => x.user_id === selecteduser)
                filterData.forEach((item) => {
                    let intValue = parseFloat(item.campaign_cost);
                    totalCost += intValue;
                    totaldelivered += item.delivered;
                    totaloptout += item.optout;
                    totaldnd += item.dnd;
                    totalsent += item.sent;
                    totalread += item.read;
                    totalfailed += item.failed;
                    contactCount += item.contact_count;
                    totalRcsOptout += item.optout_count
                });
                setCampaignData(filterData)
                setTotalCost(totalCost)
                setTotalDeliverd(totaldelivered);
                setTotalRead(totalread);
                setTotalSent(totalsent);
                setTotalFailed(totalfailed);
                setTotalOptout(totaloptout);
                setTotalDnd(totaldnd);
                setTotalData(contactCount);
                setTotalRcsOptout(totalRcsOptout)
            }
            else {
                data.data.forEach((item) => {
                    let intValue = parseFloat(item.campaign_cost);
                    totalCost += intValue;
                    totaldelivered += item.delivered;
                    totaloptout += item.optout;
                    totaldnd += item.dnd;
                    totalsent += item.sent;
                    totalread += item.read;
                    totalfailed += item.failed;
                    contactCount += item.contact_count;
                    totalRcsOptout += item.optout_count
                });
                setCampaignData(data.data)
                setTotalCost(totalCost)
                setTotalDeliverd(totaldelivered);
                setTotalRead(totalread);
                setTotalSent(totalsent);
                setTotalFailed(totalfailed);
                setTotalOptout(totaloptout);
                setTotalDnd(totaldnd);
                setTotalData(contactCount);
                setTotalRcsOptout(totalRcsOptout)
            }
        }
        else {
            setCampaignData([])
        }
        setIsLoading(false)
    }

    const fromdateHandler = (data) => {
        setFromdate(data);
    };

    const todateHandler = (data) => {
        setTodate(data);
    };

    const TemplateListDetails = async (templateid) => {
        // Open the popup when starting to fetch template details
        setOpenTemplatePopup(true)

        const data = {
            token: userToken,
            user_id: userId,
            id: templateid,
            method: "retrieveid",
        };

        try {
            let response = await fetch(`${HOST_URL}/whatsapp_template.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });
            let result = await response.json();
            if (result.success) {
                setTemplateDetails(result.data)
            } else {
                setTemplateDetails(null)
            }
        } catch (error) {
            console.log(error);
            setTemplateDetails(null)
        }
    }

    const getTemplateDetails = async (id) => {
        setShow(true);
        try {
            const { data } = await Axios.post(`${NODE_HOST_URL_v1}/rcs`, {
                token: userToken,
                user_id: userId,
                temp_id: id,
                method: "retrieve_temp_dtl",
            });

            if (data.success === true) {
                setTemplateDetails(data?.data);
                setTemplateType(data?.data?.temp_type);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const closePopup = () => {
        setOpenTemplatePopup(false)
    }

    return (
        <div>
            <AdminLayout>

                {(channel === "whatsapp" || channel === "sms" || channel === "rcs") && campaignData.length > 0 ?
                    <div className="row">
                        <div className="col-xl-12 col-xxl-5 d-flex">
                            <div className="w-100">
                                <div className="row">
                                    <div className="col-sm-2">
                                        <div className="card">
                                            <div className="card-body p-2">
                                                <h5 className="card-title mb-0">Total Data</h5>
                                                <h6 className="mt-0 mb-0">{totalData}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="card">
                                            <div className="card-body p-2">
                                                <h5 className="card-title mb-0">Delivered</h5>
                                                <h6 className="mt-0 mb-0">{totalDelivered}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="card">
                                            <div className="card-body p-2">
                                                <h5 className="card-title mb-0">Failed</h5>
                                                <h6 className="mt-0 mb-0">{totalFailed}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    {(channel === "whatsapp" || channel === "rcs") &&
                                        <div className="col-sm-2">
                                            <div className="card">
                                                <div className="card-body p-2">
                                                    <h5 className="card-title mb-0">Sent</h5>
                                                    <h6 className="mt-0 mb-0">{totalSent}</h6>
                                                </div>
                                            </div>
                                        </div>}
                                    {(channel === "sms" || channel === "rcs") &&
                                        <div className="col-sm-2">
                                            <div className="card">
                                                <div className="card-body p-2">
                                                    <h5 className="card-title mb-0">Optout</h5>
                                                    <h6 className="mt-0 mb-0">{channel === "sms" ? totalOptout : channel === "rcs" ? totalRcsOptout : 0}</h6>
                                                </div>
                                            </div>
                                        </div>}
                                    {channel === "sms" &&
                                        <div className="col-sm-2">
                                            <div className="card">
                                                <div className="card-body p-2">
                                                    <h5 className="card-title mb-0">Dnd</h5>
                                                    <h6 className="mt-0 mb-0">{totalDnd}</h6>
                                                </div>
                                            </div>
                                        </div>}
                                    {(channel === "whatsapp" || channel === "rcs") &&
                                        <div className="col-sm-2">
                                            <div className="card">
                                                <div className="card-body p-2">
                                                    <h5 className="card-title mb-0">Read</h5>
                                                    <h6 className="mt-0 mb-0">{totalRead}</h6>
                                                </div>
                                            </div>
                                        </div>}
                                    {(channel === "whatsapp" || channel === "sms") &&
                                        <div className="col-sm-2">
                                            <div className="card">
                                                <div className="card-body p-2 ">
                                                    <h5 className="card-title mb-0">Total Cost</h5>
                                                    <h6 className="mt-0 mb-0">
                                                        {parseFloat(totalCost).toFixed(2)}
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>}
                                </div>
                            </div>
                        </div>
                    </div> : null}

                <div className="row">
                    <div className="">
                        {/* {alert.status === true ? (
                                <div className={alert.bgColor} role="alert">
                                    <button
                                        type="button"
                                        className="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                    <div className="">{alert.errorMessage}</div>
                                </div>
                            ) : null} */}

                        {isLoading && <Spining />}

                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                                <div className="card flex-fill ">

                                    <div className="card-header">
                                        <div className="row">
                                            <div className="col-6">
                                                <label>Select Channel</label>
                                                <div className="input-group drop-down-icons mb-2 mr-sm-2 table1">
                                                    <div className="input-group mr-sm-2 ">
                                                        <select className='form-control' value={channel} onChange={handleChannelChange}>
                                                            <option value="">Select Channel</option>
                                                            <option value="whatsapp">Whatsapp</option>
                                                            <option value="sms">SMS</option>
                                                            <option value="rcs">RCS</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <label>Search User</label>
                                                <div className="input-group drop-down-icons mb-2 mr-sm-2 table1">
                                                    <div className="input-group mr-sm-2 ">
                                                        {/* <div className="input-group-text">User </div> */}
                                                        <Select
                                                            onChange={userHandler}
                                                            options={allUsers}
                                                            isSearchable={true}
                                                            placeholder="All Users"
                                                            styles={customStyles}

                                                        // isClearable
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-5">
                                                <label>From:</label>
                                                <div className="input-group mb-2 mr-sm-2">
                                                    <div className="input-group-text">
                                                        <FontAwesomeIcon icon={faCalendarAlt} />
                                                    </div>

                                                    <ReactDatePicker
                                                        className="form-control btn-block"
                                                        dateFormat="dd/MM/yyyy"
                                                        value={fromdate}
                                                        onChange={fromdateHandler}
                                                        selected={fromdate}
                                                        placeholderText="From Date"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-5">
                                                <label>To:</label>
                                                <div className="input-group mb-2 mr-sm-2">
                                                    <div className="input-group-text">
                                                        <FontAwesomeIcon icon={faCalendarAlt} />
                                                    </div>

                                                    <ReactDatePicker
                                                        className="form-control btn-block"
                                                        dateFormat="dd/MM/yyyy"
                                                        value={todate}
                                                        onChange={todateHandler}
                                                        selected={todate}
                                                        placeholderText="Date To"
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-2">
                                                <label></label><br />
                                                {channel === "rcs" ? <button
                                                    className="btn btn-success float-right p-2 mr-3 mt-2"
                                                    // onClick={() => this.getCampaignList(this.state.channel)}
                                                    onClick={RcsCampaignReport}
                                                >
                                                    <span>Search</span>
                                                    <FontAwesomeIcon className="fa-sm" icon={faSearch} />
                                                </button> : <button
                                                    className="btn btn-success float-right p-2 mr-3 mt-2"
                                                    // onClick={() => this.getCampaignList(this.state.channel)}
                                                    onClick={CampaignReports}
                                                >
                                                    <span>Search</span>
                                                    <FontAwesomeIcon className="fa-sm" icon={faSearch} />
                                                </button>}

                                            </div>
                                        </div>
                                    </div>

                                    {isLoading === true ? (
                                        <Spining />
                                    ) : (
                                        <div className="col-md-12 mt-2">
                                            {campaignData.length > 0 < 1 && (
                                                <div className="card d-flex justify-content-center align-items-center ">
                                                    <h6 className="mt-2">No Record Found</h6>
                                                </div>
                                            )}
                                            {campaignData?.map((item, i) => (
                                                <div className="card" key={i}>
                                                    <div className="card-body">
                                                        <div className="d-flex  justify-content-between">
                                                            <p>
                                                                {" "}
                                                                {
                                                                    channel === "whatsapp" &&
                                                                    <IoLogoWhatsapp className="text-success mr-2" style={{ fontSize: '2em' }} />
                                                                }

                                                                {
                                                                    channel === "sms" &&
                                                                    <FaSms className="text-primary mr-2" style={{ fontSize: '2em' }} />
                                                                }

                                                                {
                                                                    channel === "rcs" &&
                                                                    <img alt="Rcs Image" className="text-primary mr-2 rcs-logo-image" style={{ fontSize: '2em' }} src={RcsImage} />
                                                                }

                                                                <span>Campaign Name:{" "}</span>
                                                                <span style={{ fontWeight: "bold" }}>
                                                                    {item.campaign_name}{" "}
                                                                </span>{" "}
                                                            </p>
                                                            <p>
                                                                {channel === "sms" ? (
                                                                    <>
                                                                        {item.status === 0 ? (
                                                                            <span className="badge bg-danger">
                                                                                Deleted
                                                                            </span>
                                                                        ) : item.status === 1 ? (
                                                                            <span className="badge bg-info">
                                                                                Not Split
                                                                            </span>
                                                                        ) : item.status === 2 ? (
                                                                            <span className="badge bg-warning">
                                                                                Schedule
                                                                            </span>
                                                                        ) : item.status === 3 ? (
                                                                            <span className="badge bg-success">
                                                                                Completed
                                                                            </span>
                                                                        ) : item.status === 4 ? (
                                                                            <span className="badge bg-danger">
                                                                                Schedule Deleted
                                                                            </span>
                                                                        ) : null
                                                                        }
                                                                    </>
                                                                ) : channel === "whatsapp" ? (
                                                                    <>
                                                                        {item.status === 1 ? (
                                                                            <span className="badge bg-info">
                                                                                Submitted
                                                                            </span>
                                                                        ) : item.status === 2 ? (
                                                                            <span className="badge bg-info">
                                                                                Schedule
                                                                            </span>
                                                                        ) : item.status === 3 ? (
                                                                            <span className="badge bg-success">
                                                                                Processing
                                                                            </span>
                                                                        ) : item.status === 5 ? (
                                                                            <span className="badge bg-warning">
                                                                                Schedule
                                                                            </span>
                                                                        ) : item.status === 4 ? (
                                                                            <span className="badge bg-primary ">
                                                                                Completed
                                                                            </span>
                                                                        ) : item.status === 7 ? (
                                                                            <>
                                                                                <span className="badge bg-danger ">
                                                                                    Not Send
                                                                                    <FontAwesomeIcon
                                                                                        className="ml-1"
                                                                                        icon={faInfoCircle}
                                                                                        title="Not Send Due to Template Rejection"
                                                                                    />

                                                                                </span>
                                                                            </>
                                                                        ) : null}
                                                                    </>
                                                                ) : channel === "rcs" ? (
                                                                    <>
                                                                        {item.status === 1 ? (
                                                                            <span className="badge bg-info">
                                                                                Processing
                                                                            </span>
                                                                        ) : item.status === 2 ? (
                                                                            <span className="badge bg-info">
                                                                                Schedule
                                                                            </span>
                                                                        ) : item.status === 3 ? (
                                                                            <span className="badge bg-success mr-5">
                                                                                Completed
                                                                            </span>
                                                                        ) : item.status === 4 ? (
                                                                            <span className="badge bg-primary ">
                                                                                Schedule Deleted
                                                                            </span>
                                                                        ) : null}
                                                                    </>
                                                                ) : null}

                                                            </p>

                                                            <p>Campaign Date: {dayjs(item.camp_start_datetime).format("DD/MM/YYYY h:mm A")}</p>
                                                        </div>
                                                        <hr className="m-0 mb-1"></hr>
                                                        <div className="d-flex flex-wrap summary-data text-center">
                                                            <div className="mb-1">
                                                                <span className="text-muted"> total </span>{" "}
                                                                <br />
                                                                <span className="textvalue text-success">
                                                                    {" "}
                                                                    {/* <FontAwesomeIcon
                                                                icon={faArrowUp}
                                                                color="green"
                                                                size="1x"
                                                              />{" "} */}
                                                                    {item.contact_count}{" "}
                                                                </span>{" "}
                                                            </div>

                                                            <div className="mb-1">
                                                                <span className="text-muted">
                                                                    {" "}
                                                                    Delivered{" "}
                                                                </span>{" "}
                                                                <br />
                                                                <span className="textvalue text-success">
                                                                    {" "}
                                                                    {/* <FontAwesomeIcon
                                                                icon={faArrowUp}
                                                                color="green"
                                                                size="1x"
                                                              />{" "} */}
                                                                    {item.delivered}{" "}
                                                                </span>{" "}
                                                            </div>

                                                            <div className="mb-1">
                                                                <span className="text-muted"> Failed </span>
                                                                <br />{" "}
                                                                <span className="textvalue text-success">
                                                                    {" "}
                                                                    {/* <FontAwesomeIcon
                                                                icon={faArrowDown}
                                                                color="red"
                                                                size="1x"
                                                              />{" "} */}
                                                                    {item.failed}{" "}
                                                                </span>{" "}
                                                            </div>

                                                            {(channel === "sms" || channel === "rcs") &&
                                                                <div className="mb-1">
                                                                    <span className="text-muted"> Opt Out </span>
                                                                    <br />{" "}
                                                                    <span className="textvalue text-success">
                                                                        {" "}
                                                                        {/* <FontAwesomeIcon
                                                             icon={faArrowDown}
                                                             color="red"
                                                             size="1x"
                                                           />{" "} */}
                                                                        {channel === "sms" ? item.optout : item.optout_count}{" "}
                                                                    </span>{" "}
                                                                </div>}

                                                            {channel === "sms" &&
                                                                <div className="mb-1">
                                                                    <span className="text-muted"> DND </span>
                                                                    <br />{" "}
                                                                    <span className="textvalue text-success">
                                                                        {" "}
                                                                        {/* <FontAwesomeIcon
                                                                icon={faArrowDown}
                                                                color="red"
                                                                size="1x"
                                                              />{" "} */}
                                                                        {item.dnd || 0}{" "}
                                                                    </span>{" "}
                                                                </div>}

                                                            {channel !== "sms" &&
                                                                <>
                                                                    <div className="mb-1">
                                                                        <span className="text-muted"> Sent </span>{" "}
                                                                        <br />
                                                                        <span className="textvalue">
                                                                            {" "}
                                                                            <FontAwesomeIcon
                                                                                icon={faArrowUp}
                                                                                color="green"
                                                                                size="1x"
                                                                            />{" "}
                                                                            {item.sent}{" "}
                                                                        </span>{" "}
                                                                    </div>

                                                                    <div className="mb-1">
                                                                        <span className="text-muted"> Read </span>
                                                                        <br />{" "}
                                                                        <span className="textvalue">
                                                                            {" "}
                                                                            <FontAwesomeIcon
                                                                                icon={faArrowUp}
                                                                                color="green"
                                                                                size="1x"
                                                                            />{" "}
                                                                            {item.read}{" "}
                                                                        </span>{" "}
                                                                    </div></>}

                                                            {/* {this.state.route === 36 && (this.state.channel === "whatsapp" || this.state.channel === "all") && item.campaign_type === "whatsapp" ?
                                                                    <div className="mb-1">
                                                                        <span className="text-muted"> CTA </span>
                                                                        <br />{" "}
                                                                        {item.cta_tracking === 0 ?
                                                                            <span className="textvalue">{item.cta_tracking}</span>
                                                                            :
                                                                            <Link
                                                                                to={`/dashboard/campaign/cta-report/${item.id}`}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                <span className=" text-success">
                                                                                    <FontAwesomeIcon icon={faEye} />
                                                                                </span>
                                                                            </Link>
                                                                        }
                                                                    </div> : null} */}

                                                            <>
                                                                {/* {item.archive_status === 1 ? null : <div className="mb-1">
                                                                        <span className="text-muted"> Report </span>
                                                                        <br />{" "}
                                                                        <Link
                                                                            // to={`/dashboard/campaign/detailed-report/${item.channel}/${(this.state.channel === "rcs" || this.state.channel === "all") && item._id ? item._id : item.id}/${item.campaign_name}/${item.contact_count}`}
                                                                            to={`/dashboard/campaign/detailed-report/${item.channel === "all" && item._id ? "rcs" : item.channel === "all" && item.campaign_type === "sms" ? "sms" : item.channel === "all" && !item._id && item.campaign_type !== "sms" ? "whatsapp" : item.channel}/${(this.state.channel === "rcs" || this.state.channel === "all") && item._id ? item._id : item.id}/${item.campaign_name}/${item.contact_count}`}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                        >
                                                                            <span className=" text-success">
                                                                                <FontAwesomeIcon className="mt-3" icon={faEye} />
                                                                            </span>
                                                                        </Link>
                                                                    </div>} */}

                                                                {/* {(this.state.channel === "sms" || this.state.channel === "all") && item.campaign_type === "sms" ?
                                                                        <div className="mb-1">
                                                                            <span className="text-muted"> Other </span>
                                                                            <br />{" "}
                                                                            <span className="textvalue text-success">
                                                                                {" "}
                                                                                {item.other}{" "}
                                                                            </span>{" "}
                                                                        </div> : null} */}

                                                                {/* <div className="mb-1">
                                                                        <span className="text-muted"> Download </span>
                                                                        <br />{" "}
                                                                        <a
                                                                            href={(this.state.channel === "sms" || this.state.channel === "all") && item.campaign_type === "sms" ? `${HOST_URL_DB2}/bulk_campaign_sms.php?user_id=${item.user_id}&method=report_download&token=${item.user_token}&channel=sms&campaign_id=${item.id}&archive_status=${item.archive_status}&camp_start_datetime=${item.camp_start_datetime}&username=${item.user_name}` : (this.state.channel === "whatsapp" || this.state.channel === "all") && item.campaign_type === "whatsapp" ? `${HOST_URL}/bulk_campaign.php?user_id=${item.user_id}&method=download&campaign_id=${item.id}&channel=whatsapp&token=${item.user_token}` : (this.state.channel === "rcs" || this.state.channel === "all") && item._id ? `${NODE_HOST_URL}/rcs?user_id=${item.user_id}&token=${item.user_token}&method=campaign_report_download&campaign_id=${item._id}` : null}
                                                                            className="text-success"
                                                                        >
                                                                            <FontAwesomeIcon className="mt-3" icon={faDownload} />{" "}
                                                                        </a>
                                                                    </div> */}
                                                            </>
                                                        </div>
                                                        <div className="d-flex justify-content-between mt-1">
                                                            <div className="d-flex">
                                                                <small className="m-0, p-0">
                                                                    <span style={{ color: "black" }}>Campaign ID:</span> <span style={{ color: "#4c0af5" }}>{channel === "rcs" ? item._id : item.id}</span><span style={{ color: "black" }}>/</span>
                                                                </small>
                                                                {/* {this.state.channel === "sms" ? <small>Template ID:  xxxxxxxx{item?.template_id?.substr(-4,4)}/</small> :
                                                              <small>Template ID: {item?.template_id}/</small>} */}
                                                                {channel === "sms" ? <small style={{ color: "black" }}>Template ID: <span style={{ color: "#4c0af5" }}>{item?.template_id}</span><span className="no-style">/</span></small> :
                                                                    channel === "rcs" ? <small style={{ color: "black" }}>Template ID: <span style={{ color: "#4c0af5" }}>{item?.pannel_temp_id}</span>/</small> :
                                                                        <small>
                                                                            <span style={{ color: "black" }}>Template ID:</span> <span style={{ color: "#4c0af5" }}>{item?.template_id}</span>/
                                                                        </small>}

                                                                {/* {(this.state.channel === "whatsapp" || this.state.channel === "all") && item.campaign_type === "whatsapp" ?
                                                                        <small
                                                                            style={{
                                                                                cursor: 'pointer',
                                                                                backgroundColor: this.state.openTemplatePopup ? '#f0f0f0' : 'transparent',
                                                                            }}
                                                                            className="ml-2"
                                                                            onClick={() => this.TemplateListDetails(item?.template_id)}>
                                                                            <FontAwesomeIcon icon={faInfoCircle} /></small> : null} */}

                                                                {channel === "sms" && <small style={{ color: "black" }}>Sender ID: <span style={{ color: "#4c0af5" }}>{item.sender_id}</span>/</small>}
                                                                <small style={{ color: "black" }}>Username: <span style={{ color: "#4c0af5" }}>{item.user_name}</span></small>
                                                                {channel === "whatsapp" &&
                                                                    <small
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            backgroundColor: openTemplatePopup ? '#f0f0f0' : 'transparent',
                                                                        }}
                                                                        className="ml-2"
                                                                        onClick={() => TemplateListDetails(item?.template_id)}>
                                                                        <FontAwesomeIcon icon={faInfoCircle} /></small>}

                                                                {channel === "rcs" &&
                                                                    <small
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            backgroundColor: openTemplatePopup ? '#f0f0f0' : 'transparent',
                                                                        }}
                                                                        className="ml-2"
                                                                        onClick={() => getTemplateDetails(item?.pannel_temp_id)}>
                                                                        <FontAwesomeIcon icon={faInfoCircle} /></small>}

                                                            </div>
                                                            <small style={{ color: "black" }}>
                                                                Campaign Cost: {" "}
                                                                <span style={{ color: "#4c0af5" }}>{channel === "rcs" ? parseFloat(item.block_cr).toFixed(2) : parseFloat(item.campaign_cost).toFixed(2)}</span>
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    {channel === "whatsapp" &&
                                        <WhatsappCampaignListPreview templateDetails={templateDetails} openTemplatePopup={openTemplatePopup} closePopup={closePopup} />}
                                    {show && (
                                        <div
                                            className="position-fixed top-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                            style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050, left: 0 }}
                                        >
                                            <div
                                                className="bg-white p-3 rounded shadow w-50"
                                                style={{ maxHeight: '90vh', overflowY: 'auto', position: 'relative' }}
                                            >

                                                <button
                                                    className="btn btn-sm btn-danger position-absolute top-0 end-0 m-2"
                                                    onClick={() => setShow(false)}
                                                >
                                                    &times;
                                                </button>

                                                {templateType === 'text' ? <RcsPreview temp_type={templateType} rcsContent={templateDetails.temp_body} suggestionButtons={templateDetails.temp_suggestion} /> : <RcsPreview temp_type={templateType} cardDataArray={templateDetails?.rich_card} cardDynamicDataArray={cardDynamicDataArray} />}
                                            </div>
                                        </div>
                                    )}


                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </AdminLayout>
        </div>
    )
}

export default AdminCampaignSummaryReport
